import * as React from 'react';

import IUserModel from '../models/IUserModel';
import TopMenu from './../components/nav/TopMenu';

interface IProps {
    children?: React.ReactNode;
    user: IUserModel;
}

export default class MainLayout extends React.Component<IProps> {
    public render() {
        return (
            <div className="main-layout" style={{ width: '100% ' }}>
                <div className="content-layout" style={{ width: '100% ', minWidth: 0 }}>
                    <TopMenu {...this.props} />
                    <div className="content-container" style={{ width: '100% ' }}>{this.props.children}</div>
                </div>
            </div>
        );
    }
}
